import { ApplyCreditMemoMutation, IssueCreditMemoMutation } from "~/gql/mutations/creditMemo.generated";
import {
	AdjustInvoiceMutation,
	RecordInvoicePaymentMutation,
	RetryInvoiceExportMutation,
	RetryPaymentExportMutation,
	VoidInvoiceMutation,
	WaiveInvoiceLateChargeMutation
} from "~/gql/mutations/invoice.generated";
import { GetCreditMemoNumbersQuery, GetCreditMemoQuery } from "~/gql/queries/creditMemo.generated";
import {
	GetCustomerNamesForInvoicesQuery,
	GetInvoiceHistoryQuery,
	GetInvoiceQuery
} from "~/gql/queries/invoice.generated";

export const invoiceEndpoints = {
	AdjustInvoice: {
		invalidatesTags: ["CustomerReceivables", "Invoice"] as AddTagTypes,
		transformResponse: (res: AdjustInvoiceMutation) => res
	},
	ApplyCreditMemo: {
		invalidatesTags: ["CustomerReceivables", "Invoice", "OrderPayments", "Orders"] as AddTagTypes,
		transformResponse: (res: ApplyCreditMemoMutation) => res
	},
	GetCreditMemo: {
		providesTags: ["Invoice", "OrderPayments"] as AddTagTypes,
		transformResponse: (res: GetCreditMemoQuery) => res
	},
	GetCreditMemoNumbers: {
		providesTags: ["Invoice", "OrderPayments"] as AddTagTypes,
		transformResponse: (res: GetCreditMemoNumbersQuery) => res
	},
	GetCustomerNamesForInvoices: {
		transformResponse: (res: GetCustomerNamesForInvoicesQuery) => res
	},
	GetInvoice: {
		providesTags: ["Invoice"] as AddTagTypes,
		transformResponse: (res: GetInvoiceQuery) => res
	},
	GetInvoiceHistory: {
		providesTags: ["Invoice"] as AddTagTypes,
		transformResponse: (res: GetInvoiceHistoryQuery) => res
	},
	IssueCreditMemo: {
		invalidatesTags: ["CustomerReceivables", "Invoice", "OrderPayments", "Orders"] as AddTagTypes,
		transformResponse: (res: IssueCreditMemoMutation) => res
	},
	RecordInvoicePayment: {
		invalidatesTags: ["CustomerReceivables", "Invoice", "OrderPayments", "Learning"] as AddTagTypes,
		transformResponse: (res: RecordInvoicePaymentMutation) => res
	},
	RetryInvoiceExport: {
		invalidatesTags: ["Invoice"] as AddTagTypes,
		transformResponse: (res: RetryInvoiceExportMutation) => res
	},
	RetryPaymentExport: {
		invalidatesTags: ["Invoice"] as AddTagTypes,
		transformResponse: (res: RetryPaymentExportMutation) => res
	},
	VoidInvoice: {
		invalidatesTags: ["Invoice"] as AddTagTypes,
		transformResponse: (res: VoidInvoiceMutation) => res
	},
	WaiveInvoiceLateCharge: {
		invalidatesTags: ["CustomerReceivables", "Invoice"] as AddTagTypes,
		transformResponse: (res: WaiveInvoiceLateChargeMutation) => res
	}
};
